import ShipmentPosition from '../../../../../types/api/shipment-position'
import UploadedFile from '../../../../../types/api/uploaded-file'
import { StrapiCreate } from '../../../../../types/strapi/strapi'
import { ListItem } from '../types/form-values'

export default function useCreateShipmentPositionQueryArgExtractor() {
    return (
        pos: ListItem['positions'][number],
        item: ListItem,
        files?: { sourceFile: UploadedFile }
    ): StrapiCreate<ShipmentPosition> => {
        const floodsInAccumulation =
            pos.floodsInAccumulation ?? item.calculationPosition?.floodsInAccumulation

        return {
            data: {
                copies: pos.copies ?? 0,
                labelName: pos.name,
                comment: pos.comment,
                sourceFile: files?.sourceFile.id,
                floodsInAccumulation,
            },
        }
    }
}
